import React, { useEffect, useState, useContext, useRef } from "react";
import Modal from "@mui/joy/Modal";
import ModalClose from "@mui/joy/ModalClose";
import ModalDialog from "@mui/joy/ModalDialog";
import DataTable from "react-data-table-component";
import PanoramaIcon from "@mui/icons-material/Panorama";
import Carousel from "../components/Carousel.jsx";
import { useForm } from "react-hook-form";
import Request_Modal from "../page/Request_Modal.jsx";
import Button from "@mui/material/Button";
import ImageSearchIcon from "@mui/icons-material/ImageSearch";
import { Link } from "react-router-dom";
import toast from "react-hot-toast";
import * as XLSX from "xlsx";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import ImageIcon from "@mui/icons-material/Image";
import { ImageContext } from "../page/ApiContext.jsx";
import { MultiSelect } from "react-multi-select-component";

import { getCookie } from "../components/Cookie.jsx";

const customStyles = {
  rows: {
    style: {
      minHeight: "3rem",
      fontSize: "0.875rem",
      textAlign: "center",
    },
  },
  cells: {
    style: {
      wordWrap: "break-word",
      whiteSpace: "normal",
      fontSize: "0.7rem",
      textAlign: "center",
      display: "flex",
      justifyContent: "center",
    },
  },
  headCells: {
    style: {
      backgroundColor: "#f1f4f9", // Set header background color to light gray
      color: "black", // Set header text color to black
      fontSize: "0.7rem", // Set font size to small (14px)
      textAlign: "center", // Center-align the text in header cells
      textAlign: "center", // Center-align the text in cells
      display: "flex",
      justifyContent: "center",
    },
  },
};

const actionLogStyles = {
  rows: {
    style: {
      minHeight: "3rem",
      fontSize: "0.875rem",
      textAlign: "center",
    },
  },
  cells: {
    style: {
      wordWrap: "break-word",
      whiteSpace: "pre-wrap",  // Allow multi-line wrapping
      fontSize: "0.75rem",
      textAlign: "center", // Align left for better readability
      display: "block", // Prevent flex from restricting text
      overflow: "visible", // Ensure full visibility
    },
  },
  headCells: {
    style: {
      backgroundColor: "#f1f4f9",
      fontWeight: 'bold',
      color: '#1F2937',  // This is the Tailwind shade 'text-gray-900'
      fontSize: "0.75rem",
      textAlign: "center",
      display: "flex",
      justifyContent: "center",
    },
  },
};

const dropdownStyles = {
  control: (provided) => ({
    ...provided,
    maxHeight: "60px", // Control the height of the select component
    overflowY: "auto", // Enable vertical scrolling
  }),
  multiValueContainer: (provided) => ({
    ...provided,
    maxHeight: "100px", // Control the height of the selected values container
    overflowY: "auto", // Enable vertical scrolling inside selected values
  }),
};

const LayoutModalDialog = ({
  requestType,
  dateData,
  setLayout,
  layout,
  modalData,
  term,
  batchData,
  status,
  setNotificationCount,
  batchId,
  requestState,
  action_log_data,
  proxy_data,
  day,
  checkSingleLive,
  functionalityIds,
}) => {
  const data = Array.isArray(modalData) ? modalData : [];
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [dueDate, setDueDate] = useState("");

  const notification =
    Array.isArray(batchData[0]?.comment) || Array.isArray(batchData[0]?.file)
      ? batchData
      : [];

  const [reqData, setReqData] = useState(modalData);
  const [requestLayout, setRequestLayout] = useState(undefined);
  // const [selectedRowId, setSelectedRowId] = useState(null);
  const [requestModalData, setRequestModalData] = useState(null);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [apiData, setApiData] = useState([]);
  const [viewType, setViewType] = useState("sent");
  const [bellData, setBellData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [open, setOpen] = React.useState(false);
  const [formData, setformData] = useState([]);
  const { imageResponse, setImageResponse } = useContext(ImageContext);
  const [selectedImageUrl, setSelectedImageUrl] = useState("");
  const [selectedImageData, setSelectedImageData] = useState("");
  const [currentSlideIndex, setCurrentSlideIndex] = useState(0);
  const [reqTerm, setReqTerm] = useState(undefined);
  const { setRowId } = useContext(ImageContext);
  const [minDate, setMinDate] = useState("");
  const [batchD, setBatchD] = useState([]);
  const [notify, setnotify] = useState(notification);

  const downloadLinkRef = useRef(null);

  const [users, setUsers] = useState([]);

  const parts = modalData?._id && modalData?._id.split("$");
  const token = getCookie("sqa_token");
  const username = localStorage.getItem("email");
  const role = localStorage.getItem("is_admin");
  const [searchText, setSearchText] = useState(""); 
  const [filteredReqSrachData, setFilteredReqSearchData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
  const lowercasedSearchText = searchText.toLowerCase();

  if (Array.isArray(modalData)) {
    const filtered = modalData.filter((row) => {
      const floatConv =
        row.try_cnt && Number.isInteger(Number(row.try_cnt))
          ? Number(row.try_cnt).toFixed(1)
          : row.try_cnt;

      return (
        row._id?.toString().toLowerCase().includes(lowercasedSearchText) ||
        row.time_tag?.toLowerCase().includes(lowercasedSearchText) ||
        floatConv?.toString().includes(lowercasedSearchText) ||
        row.status_code?.toString().includes(lowercasedSearchText)
      );
    });
    setFilteredReqSearchData(filtered);
  }
}, [searchText, modalData]);

    const handleSearch = (e) => {
    setSearchText(e.target.value); 
  };

  const handleSlideChange = (index) => {
    setCurrentSlideIndex(index);
  };
  useEffect(() => {
    // Get the current date
    const today = new Date();

    // Format the date to YYYY-MM-DD
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    const formattedDate = `${year}-${month}-${day}`;

    // Set the minimum date
    setMinDate(formattedDate);
    getUsers();
  }, []);

  const getUsers = async () => {
    try {
      const url = `/sqa/api/get_all_users/`;
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await response.json();

      if (data.result?.length > 0) {
        setUsers(data.result);
      } else {
        setUsers([]);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const confirmNotification = async function () {
    try {
      const response = await fetch("/sqa/api/create_batch_notifications/", {
        method: "POST",
        body: formData, // Send as FormData
        headers: {
          // Specify the content type for FormData
          Authorization: `Bearer ${token}`, // Replace with your actual token or authentication header
          // Add any other headers you need here
        },
      });

      if (!response.ok) {
        toast.error(`Message not sent for Batch ID: ${modalData?._id}`);
        throw new Error("Network response was not ok");
      }

      const data = await response.json();

      // Check if `data.result` exists and has a length of 0
      if (!data.result || data.result.length === 0) {
        toast.error(`Message not sent for Batch ID: ${modalData?._id}`);
        return; // Exit the function early if there's no data
      }

      bellIconData();

      toast.success(`Message sent for Batch ID: ${modalData?._id}`);
      setBatchD(data); // Assuming you have setModalData to update modal data

      // Clear form fields after successful submission
      setTitle("");
      setDescription("");
      setDueDate("");
      setSelectedUsers([]);
      reset({
        title: "",
        description: "",
        dueDate: "",
        assignedTo: [],
        comment: "",
      });

      setLayout(undefined);
    } catch (error) {
      // Handle error (e.g., show an error message)
      toast.error("An error occurred. Please try again.");
      console.error(error);
    }
  };

  const handleResetBatch = async (batch_id, request_type) => {
    const isConfirmed = window.confirm("Are you sure you want to reset?");
    if (!isConfirmed) return; // Stop execution if the user cancels
    try {
        const response = await fetch("/sqa/api/reset_batch/", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({ 'batch_id':batch_id, 'request_type':request_type })
        });

        const data = await response.json();

        if (!response.ok) {
          toast.error("Something went wrong");
          throw new Error("Network response was not ok");
        }

        if (data.error_list.length === 0) {
            toast.success("Reset successfully");
            setLayout(undefined);
            checkSingleLive(batchId);
        } else {
            toast.error("Reset failed");
            // console.error("Batch reset failed:", data.error_list);
        }
    } catch (error) {
        // console.error("Error calling API:", error);
        toast.error("Something went wrong");
    }
  };

  const {
    register,
    reset,
    setValue,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = (isAgree) => {
    if (isAgree && confirmNotification()){
      // Form will be cleared in confirmNotification on success
    // setSelectedUsers([]);
    // setValue("title", "");
    // setValue("description", "");
    // setValue("dueDate", "");
    // }
    // else{
    //   setTitle( batchData[0].title);
    //   setDescription( batchData[0].description);
    //   setDueDate( batchData[0].dueDate);
    //   const preselectedOptions = batchData[0]?.assignedTo?.map((userEmail) => ({
    //     value: userEmail,
    //     label: userEmail,
    //   }));
    //   setSelectedUsers(preselectedOptions);
    }
    setOpen(false);
  };

  useEffect(() => {
    // Simulate API call
    bellIconData();
  }, []);

  // useEffect hooks that were populating form fields with batchData
  // useEffect(() => {
  //   if (batchData && batchData[0]?.assignedTo) {
  //     const preselectedOptions = batchData[0]?.assignedTo?.map((userEmail) => ({
  //       value: userEmail,
  //       label: userEmail,
  //     }));
  //     setSelectedUsers(preselectedOptions);
  //     setValue('assignedTo', preselectedOptions.map(option => option.value));
  //   }
  // }, [batchData]);  

  // useEffect(() => {
  //   if (batchData && batchData[0]) {
  //     setTitle(batchData[0]?.title || "");
  //     setDescription(batchData[0]?.description || "");
  //     setDueDate(batchData[0]?.dueDate || "");
  
  //     // Sync with React Hook Form
  //     setValue("title", batchData[0]?.title || "");
  //     setValue("description", batchData[0]?.description || "");
  //     setValue("dueDate", batchData[0]?.dueDate || "");
  //   }
  // }, [batchData]);

  const onSubmit = async (data) => {
    try {
      const form = new FormData();
      form.append("title", data.title);
      form.append("assignedTo", data.assignedTo);
      form.append("description", data.description);
      form.append("comment", data.comment);
      form.append("createdBy", username);
      form.append("batchId", modalData?._id);
      form.append("type", "batch");
      form.append("dueDate", data.dueDate);
      form.append("is_done_count", modalData?.is_done_count)
      form.append("is_fail_count", modalData?.is_fail_count)
      form.append("is_exhausted_count", modalData?.is_exhausted_count)
      form.append("status", modalData?.status)

      // Append the file if it exists
      if (data.file && data.file[0]) {
        form.append("file", data.file[0]);
      }
      setformData(form);
      handleClickOpen();
    } catch (error) {
      // Handle error (e.g., show an error message)
      console.error("Error preparing form data:", error);
    }
  };

  const downloadExcel = () => {
    const documents = modalData;
    //step: 1 - format data

    const formattedData = documents.map((doc) => {
      const { _id, time_tag, try_cnt, status_code } = doc;

      return {
        ID: _id,
        "Creation Time": time_tag,
        "Try Count": try_cnt,
        "Response Status": status_code,
        "Status Message": "Ok",
        "Last Update Action": "N/A",
        "Last Update Time": "N/A",
      };
    });

    // Step 2: Convert the modified data to an Excel file
    const worksheet = XLSX.utils.json_to_sheet(formattedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Data");
    XLSX.writeFile(workbook, "data.xlsx");
  };

  useEffect(() => {
    if (modalData) {
      setReqData(modalData[0]);
    }
  }, [modalData]);

  const action = action_log_data;
  const reqDetails = modalData;

  const logfilteredData = (() => {
    let dataToFilter=action_log_data;

    return (
      dataToFilter &&
      dataToFilter.filter((item) =>
        Object.values(item).some((value) =>
          value?.toString()?.toLowerCase()?.includes(searchQuery.toLowerCase())
        )
      )
    );
  })();

  const handleFetch = async (rowId) => {
    if (rowId == undefined) {
      return;
    }

    const defaultType = "request";
    const requestId = rowId;

    // Retrieve username from local storage or use a default

    if (!username) {
      return;
    }

    try {
      const response = await fetch(
        `/sqa/api/batch_request_comment/?username=${encodeURIComponent(
          username
        )}&type=${encodeURIComponent(
          defaultType
        )}&identifier=${encodeURIComponent(requestId)}`,
        {
          method: "GET", // or 'POST' if applicable
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`, // Replace with your actual token or authentication header
            // Add any other headers you need here
          },
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();
      setApiData(data?.result[0]);
    } catch (err) {}
  };

  useEffect(() => {
    if (bellData && bellData.length > 0) {
      const filtered = bellData.filter((item) => {
        if (viewType === "sent") {
          return item.createdBy === username;
        } else if (viewType === "received") {
          if (role === "true") {
            return item.createdBy != username;
          }

          return item.assignedTo.includes(username);
        }
        return false;
      });
      setFilteredData(filtered);
      // setNotificationCount(filtered.length);
      if (viewType == "received") {
        const getFilteredIds = (filtered) => {
          return filtered
            .filter((item) => !item?.seen?.includes(username))
            .map((item) => item._id);
        };

        const filteredIds = getFilteredIds(filtered);

        if (filteredIds && filteredIds?.length != 0) {
          notificationFunction(filteredIds);
        }
        setNotificationCount(0);
      }
    }
  }, [viewType, bellData]);

  const notificationFunction = async (filteredIds) => {
    const document_ids = filteredIds;

    try {
      const response = await fetch("/sqa/api/notification_count_update/", {
        method: "POST", // Specify the request method
        headers: {
          "Content-Type": "application/json", // Specify the content type
          Authorization: `Bearer ${token}`, // Include authorization token if needed
        },
        body: JSON.stringify(document_ids), // Convert the data object to a JSON string
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      await response.json(); // Parse the response as JSON
    } catch (error) {
      console.error("Error:", error); // Handle any errors
    }
  };

  const bellIconData = async () => {
    try {
      const response = await fetch(
        `/sqa/api/notification_dashboard_data/?username=${username}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      // const data = result?.data || [];

      const countData = data?.result[0]?.filter((item) => {
        if (!item?.seen?.includes(username)) {
          if (role === "admin") {
            return item.createdBy != username;
          }
          return item.assignedTo.includes(username);
        }
      });

      setBellData(data?.result[0] || []);

      setNotificationCount(countData.length);
    } catch (error) {
      console.error("Error in bellicon data", error);
    }
  };

  const dataClear = () => {
    setLayout(undefined);
    setSelectedImageUrl("");
    setSelectedImageData("");
    setCurrentSlideIndex(0);
    setImageResponse([]);
  };

  const sentColumns = [
    {
      name: <div>Batch Id / Request Id</div>,
      width: "full",
      selector: (row) => row.batchId,
      sortable: true,
      cell: (row) => (
        <div className="whitespace-normal break-words text-left">
          {row.type === "batch" ? row.batchId : row.requestId}
        </div>
      ),
    },
    {
      name: <div>Title</div>,
      width: "full",
      selector: (row) => row.title,
      sortable: true,
    },
    {
      name: <div>Due Date</div>,
      width: "full",
      selector: (row) => row.dueDate || "-",
      sortable: true,
    },
    {
      name: <div>Status</div>,
      width: "full",
      selector: (row) => row.status,
      sortable: true,
      cell: (row) => {
        let textColorClass;

        const formattedStatus =
          typeof row.status === "string"
            ? row.status.charAt(0).toUpperCase() +
              row.status.slice(1).toLowerCase()
            : " - ";

        switch (formattedStatus) {
          case "Open":
            textColorClass =
              "text-blue-500 bg-[#dae6ff] w-[5rem] py-2 rounded-md";
            break;
          case "Overdue":
            textColorClass =
              "text-red-500 bg-[#fbccd6] w-[5rem] py-2 rounded-md";
            break;
          case "Live":
            textColorClass =
              "text-purple-500 bg-[#e0d4fc] w-[5rem] py-2 rounded-md";
            break;
          default:
            textColorClass = "text-gray-700";
        }

        return (
          <div className={`whitespace-normal break-words ${textColorClass}`}>
            {formattedStatus}
          </div>
        );
      },
    },
    {
      name: <div>View</div>,
      width: "full",
      selector: (row) => "",
      sortable: false,
      cell: (row) => (
        <Link
          onClick={() => setRowId(row?._id)}
          className="border p-1 border-black rounded-md hover:border-[#4880FF] hover:text-[#4880FF]"
          to="/notification"
          style={{ whiteSpace: "normal", wordWrap: "break-word " }}
        >
          <ImageSearchIcon />
        </Link>
      ),
    },
    {
      name: <div className="hidden">Hidden Column</div>,
      selector: (row) => row.createdAt,
      sortable: true,
      omit: true,
    },
  ];

  // Note: Ensure that the `hiddenField` is present in your data rows

  const receivedColumns = [
    {
      name: <div>Batch Id / Request Id</div>,
      width: "full",
      selector: (row) => row.batchId,
      sortable: true,
      cell: (row) => (
        <div className="whitespace-normal break-words text-left">
          {row.type === "batch" ? row.batchId : row.requestId}
        </div>
      ),
    },
    { name: "Title", selector: (row) => row.title, sortable: true },
    { name: "Due Date", selector: (row) => row.dueDate, sortable: true },
    {
      name: "Status",
      selector: (row) => row.status,
      sortable: true,
      cell: (row) => {
        let textColorClass;

        // Check if status exists and is a string before formatting
        const formattedStatus =
          typeof row.status === "string"
            ? row.status.charAt(0).toUpperCase() +
              row.status.slice(1).toLowerCase()
            : " - "; // Default value if status is undefined or not a string

        switch (formattedStatus) {
          case "Open":
            textColorClass =
              "text-blue-500 bg-[#dae6ff] w-[5rem] py-2 rounded-md";
            break;
          case "Overdue":
            textColorClass =
              "text-red-500 bg-[#fbccd6] w-[5rem] py-2 rounded-md";
            break;
          case "Live":
            textColorClass =
              "text-purple-500 bg-[#e0d4fc] w-[5rem] py-2 rounded-md";
            break;
          default:
            textColorClass = "text-gray-700";
        }

        return (
          <div className={`whitespace-normal break-words ${textColorClass}`}>
            {formattedStatus}
          </div>
        );
      },
    },
    {
      name: "View",
      selector: (row) => "",
      sortable: false,
      cell: (row) => (
        <Link
          onClick={() => setRowId(row?._id)}
          className="border p-1 border-black rounded-md hover:border-[#4880FF] hover:text-[#4880FF]"
          to="/notification"
          style={{ whiteSpace: "normal", wordWrap: "break-word " }}
        >
          <ImageSearchIcon />
        </Link>
      ),
    },
    {
      name: <div className="hidden">Hidden Column</div>,
      selector: (row) => row.createdAt,
      sortable: true,
      omit: true,
    },
  ];

  const columns = viewType === "sent" ? sentColumns : receivedColumns;

  const requestcolumns = [
    {
      name: <div>Document ID</div>,
      width: "11rem",
      selector: (row) => row._id,
      sortable: true,
      cell: (row) => (
        <div className="whitespace-normal break-words text-left">{row._id}</div>
      ),
    },
    {
      name: <div>Creation Time</div>,
      width: "full",
      selector: (row) => row.time_tag,
      sortable: true,
    },
    {
      name: <div>Try Count</div>,
      width: "full",
      selector: (row) => row.try_cnt.toFixed(1), // Round to 1 decimal point
      sortable: true,
    },
    {
      name: <div>Response Status</div>,
      width: "full",
      selector: (row) => row.status_code,
      sortable: true,
    },
    {
      name: <div>Status Message</div>,
      width: "full",
      selector: (row) => {
        if (row.status_code === 200) {
          return "Ok";
        } else if (row.try_cnt > 3 && row.is_done == 0 && row.is_fail == 1) {
          return "Exhausted";
        } else {
          return "Failed";
        }
      },
    },

    // {
    //   name: <div>Last Update Action</div>,
    //   width: "full",
    //   selector: (row) => "N/A",
    //   sortable: true,
    // },
    // {
    //   name: <div>Last Update Time</div>,
    //   width: "full",
    //   selector: (row) => "N/A",
    //   sortable: true,
    // },
    {
      name: <div>Actions</div>,
      width: "full",
      selector: (row) => row.src_id,
      sortable: false,
      cell: (row) => (
        <div style={{ whiteSpace: "normal", wordWrap: "break-word " }}>
          <button
            onClick={() => {
              setRequestLayout("fullscreen");
              setRequestModalData(row);
              setReqTerm("requestNotification");
              handleFetch(row?._id);
            }}
            className="border-2 border-blue-500 text-blue-500 py-2 px-4 rounded-lg hover:bg-blue-500 hover:text-white transition-colors"
          >
            Notify
          </button>
        </div>
      ),
    },
  ];

  const action_log = [
    { name: "User_Id", selector: row => row.username, sortable: true },
    { 
      name: "Time", 
      selector: row => row.time, 
      sortable: true 
    },
    { name: "Action", selector: row => (<div style={{ whiteSpace: "pre-wrap", overflow: "visible" }}>{row.action}</div>),
      sortable: true },
  ];


  const lastRerun = action
  .filter(row => row.fn_id === 203) // Filter rerun actions
  .sort((a, b) => new Date(b.time) - new Date(a.time)) // Sort by latest time
  .map(row => `${row.username} --- ${new Date(row.time).toLocaleString("en-GB", {
      hour: "2-digit",
      minute: "2-digit",
    })} ${new Date(row.time).toLocaleDateString("en-GB")}`)[0] || ""; 

  const batch_column = [
    { name: "Comments", selector: (row) => row.comment || "-", sortable: true },
    { name: "By", selector: (row) => row.createdBy, sortable: true },
    { name: "Date-Time", selector: (row) => row.createdAt, sortable: true },
  ];

  // Define custom styles for the DataTable
  const handleImageClick = (url, item) => {
    setSelectedImageUrl(url);
    setSelectedImageData(item);
  };

  if (imageResponse == undefined) {
    return [];
  }

  const currentImage = imageResponse[currentSlideIndex];
  const generationDateTime = currentImage
    ? `${new Date(
        currentImage.create_datetime || currentImage.scrape_date
      ).toLocaleDateString()} ${new Date(
        currentImage.create_datetime || currentImage.scrape_date
      ).toLocaleTimeString()}`
    : "N/A";

  const handleRowclicked = (row) => {
    setReqTerm("reqData");
    setRequestLayout("fullscreen");
    setApiData(row);
  };
  return (
    <React.Fragment>
      {term === "request" && (
        <Modal open={!!layout} onClose={() => setLayout(undefined)}>
          <ModalDialog
            layout={layout}
            sx={{
              margin: "auto",
              width: "80vw",
              overflowY: "scroll",
              // height: "95%",
              height: {
                xs: "80%", // For extra small screens
                sm: "85%", // For small screens
                md: "60%", // For medium screens
                lg: "82%", // For large screens
                xl: "70%", // For extra large screens
              },
            }}
          >
            <ModalClose />
            <div className="text-xl font-semibold py-2">{requestType}</div>
            <div>
              <div className="text-xs">
                <h1>{modalData?.combined_result}</h1>
                <div className="w-full flex justify-between items-center pb-4">
                    {/* Left-aligned CSV button */}
                    <div className="text-[#4880FF] border-2 border-[#4880FF] p-1 rounded-lg cursor-pointer hover:bg-[#4880FF] hover:text-white"
                      onClick={downloadExcel}
                    >
                      <InsertDriveFileIcon fontSize="small" /> CSV
                    </div>

                    {/* Right-aligned Reset button */}
                    {functionalityIds.includes(207) && day 
                    // && requestType !== "Picked Request"  
                    && (
                      <div
                        onClick={() => {
                          handleResetBatch(batchId, requestType);
                        }}
                        className="mr-10 text-sm text-[#4880FF] border-2 border-[#4880FF] p-1 rounded-lg cursor-pointer hover:bg-[#4880FF] hover:text-white ml-auto"
                      >
                        Reset
                      </div>
                    )}
                    {/* <div
                      onClick={() => {
                        if (requestState) {
                          setReqTerm("requestScreenshot");
                          setRequestLayout("fullscreen");
                          setRequestModalData(modalData);
                        }
                      }}
                      className={`border-2 border-[#4880FF] text-[#4880FF] rounded-lg p-1 ${
                        requestState
                          ? "cursor-pointer hover:bg-[#4880FF] hover:text-white"
                          : "cursor-not-allowed"
                      }`}
                      // style={{
                      //   pointerEvents: requestState ? "auto" : "none",
                      // }}
                    >
                      <PanoramaIcon fontSize="small" /> View Screenshot
                    </div> */}
                </div>
              </div>
              <div style={{ width: "full", height: "full" }}>
                  <div className="mb-4 flex justify-end">
                    <input
                      type="text"
                      placeholder="Search Request Data..."
                      value={searchText}
                      onChange={handleSearch}
                      className="border rounded-lg py-2 px-4 w-1/4 rounded-lg"
                    />
                  </div>
                <DataTable
                  columns={requestcolumns}
                  data={filteredReqSrachData}
                  defaultSortFieldId={2}
                  defaultSortAsc={false}
                  noDataComponent={
                    <div className="py-10">No Records Found</div>
                  }
                  persistTableHead
                  pagination
                  highlightOnHover
                  pointerOnHover
                  onRowClicked={handleRowclicked}
                  customStyles={customStyles}
                  // fixedHeader={true}
                  // fixedHeaderScrollHeight="300px"
                />
                <Request_Modal
                  term={reqTerm}
                  status={status}
                  setLayout={setRequestLayout}
                  layout={requestLayout}
                  apiData={apiData}
                  modalData={requestModalData}
                  batchId={batchId}
                />
              </div>
            </div>
          </ModalDialog>
        </Modal>
      )}

      {term === "action_log" && (
        <Modal open={!!layout} onClose={() => setLayout(undefined)}>
          <ModalDialog
            layout={layout}
            sx={{
              margin: "auto",
              width: "95vw",
              height: "95vh", // Ensure it is responsive
            }}
          >
            <ModalClose />
            <DialogTitle> Action Log - {modalData._id}</DialogTitle>

            <DialogContent>
              <div className="container mx-auto p-4">
                <form className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 pb-5">
                  <div>
                    <label className="block text-sm font-medium text-gray-700">
                      Batch ID
                    </label>
                    <input
                      type="text"
                      className="bg-gray-200 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                      value={modalData?._id}
                      disabled
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700">
                      Client
                    </label>
                    <input
                      value={modalData?.client_id}
                      disabled
                      type="text"
                      className="bg-gray-200 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700">
                      Website
                    </label>
                    <input
                      disabled
                      type="text"
                      className="bg-gray-200 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                      value={modalData?._id.split("$")[3]}
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700">
                      Creation Time
                    </label>
                    <input
                      type="text"
                      className="bg-gray-200 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                      value={modalData?.time_tag}
                      disabled
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700">
                      Proxy Used
                    </label>
                    <input
                      type="text"
                      className="bg-gray-200 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                      value={proxy_data}
                      disabled
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700">
                      Status
                    </label>
                    <input
                      type="text"
                      className={`bg-${modalData?.status === 'Completed' ? 'green-100' : 'gray-200'} 
                                  border border-gray-300
                                  text-${modalData?.status === 'Completed' ? 'green-900' : 'gray-900'} 
                                  text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5`}
                      value={modalData?.status}
                      disabled
                    />
                  </div>
                
                  {/* New 'Last Rerun' field spanning 2 columns */}
                  <div className="col-span-2">
                    <label className="block text-sm font-medium text-gray-700">
                      Last Rerun By
                    </label>
                    <input
                      type="text"
                      className="bg-gray-200 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                      value={lastRerun}
                      disabled
                    />
                  </div>
                </form>
                
              </div>
              <div className="flex justify-between items-center w-full">
                {/* Left side - Title */}
                <h2 className="text-lg font-semibold">Action Log</h2>

                {/* Right side - Search Box */}
                <div className="w-1/3">
                  <input
                    type="text"
                    placeholder="Search here..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    className="border rounded-md px-4 py-2 w-full"
                  />
                </div>
              </div>
              <div className="mt-4" style={{ width: "100%" }}>
                <DataTable
                  columns={action_log}
                  // data={action}
                  data={logfilteredData}
                  pagination
                  highlightOnHover
                  pointerOnHover
                  customStyles={actionLogStyles} // Apply custom styles here
                  noDataComponent={<div className="py-10">No Records Found</div>}
                  persistTableHead
                  defaultSortFieldId={2}  // Sort by "Time" (Index starts from 1)
                  defaultSortAsc={false}  // false = Descending order
                />
              </div>
            </DialogContent>
          </ModalDialog>
        </Modal>
      )}

      {term === "batch_notification" && (
        <Modal
          open={!!layout}
          onClose={() => {
            setLayout(undefined);
            reset();
            setSelectedUsers([]);
            setTitle('');
            setDescription('');
            setDueDate('');
          }}
        >
          <ModalDialog
            layout={layout}
            sx={{
              margin: "auto",
              width: "80vw",
              height: "90vh", // Ensure it is responsive
            }}
          >
            <ModalClose />
            <DialogTitle> Add Notification Detail</DialogTitle>
            <DialogContent>
              <div className="container mx-auto p-4">
                <div className="col-span-full">
                  <label className="block text-sm font-medium text-gray-700">
                    Title<span className="text-red-500">*</span>
                  </label>
                  <input
                    // defaultValue={batchData[0]?.title || ""}
                    {...register("title", { required: "Title is required" })}
                    type="text"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                    value={title}
                    onChange={(e) => {setTitle(e.target.value);
                      setValue("title", e.target.value);
                    }}
                  />
                  {errors.title && (
                    <span className="text-red-500">{errors.title.message}</span>
                  )}
                </div>

                <form
                  onSubmit={handleSubmit(onSubmit)}
                  className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 pb-5"
                >
                  <div>
                    <label className="block text-sm font-medium text-gray-700">
                      Batch Id
                    </label>
                    <input
                      type="text"
                      className="bg-gray-200 border border-gray-300 text-gray-500 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 cursor-not-allowed"
                      value={modalData?._id}
                      disabled
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700">
                      Client Name
                    </label>
                    <input
                      value={parts?.[2] || ""}
                      disabled
                      type="text"
                      className="bg-gray-200 border border-gray-300 text-gray-500 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 cursor-not-allowed"
                    />
                  </div>
                  {/* <div>
                    <label className="block text-sm font-medium text-gray-700">
                      Website
                    </label>
                    <input
                      type="text"
                      className="bg-gray-200 border border-gray-300 text-gray-500 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 cursor-not-allowed"
                      value={parts?.[3] || ""}
                    />
                  </div> */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700">
                      Website
                    </label>
                    <input
                      value={parts?.[3] || ""}
                      disabled
                      type="text"
                      className="bg-gray-200 border border-gray-300 text-gray-500 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 cursor-not-allowed"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700">
                      Creation Time
                    </label>
                    <input
                      type="text"
                      className="bg-gray-200 border border-gray-300 text-gray-500 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500  w-full p-2.5 "
                      value={modalData?.time_tag}
                      disabled
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700">
                      Due Date<span className="text-red-500">*</span>
                    </label>
                    <input
                      {...register("dueDate", {
                        required: "Due Date is required",
                        validate: (value) => {
                          const selectedDate = new Date(value);
                          const today = new Date();
                          return (
                            selectedDate >= today ||
                            "Due Date cannot be in the past"
                          );
                        },
                      })}
                      type="date"
                      min={minDate}
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                      // defaultValue={batchData[0]?.dueDate || ""}
                      value={dueDate}
                      onChange={(e) => {setDueDate(e.target.value);setValue('dueDate',e.target.value)}}
                    />
                    {errors.dueDate && (
                      <span className="text-red-500">
                        {errors.dueDate.message}
                      </span>
                    )}
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700">
                      Proxy Used
                    </label>
                    <input
                      type="text"
                      className="bg-gray-200 border border-gray-300 text-gray-500 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 cursor-not-allowed"
                      value={proxy_data}
                      disabled
                    />
                  </div>
                  {/* <div>
                    <label className="block text-sm font-medium text-gray-700">
                      Last Action
                    </label>
                    <input
                      value="Rerun"
                      disabled
                      type="text"
                      className="bg-gray-200 border border-gray-300 text-gray-500 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 cursor-not-allowed"
                    />
                  </div> */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700">
                      Assign To<span className="text-red-500">*</span>
                    </label>
                    {/* <Select
                      styles={dropdownStyles}
                      isMulti
                      defaultValue={preSelectedOptions}
                      placeholder={<div>Select users</div>}
                      name="assignedTo"
                      options={users[0]?.map((user) => ({
                        value: user.email,
                        label: user.email,
                      }))}
                      onChange={(selectedOptions) => {
                        const selectedValues = selectedOptions.map(
                          (option) => option.value
                        );
                        setValue("assignedTo", selectedValues, {
                          shouldValidate: true,
                        });
                      }}
                      className="basic-multi-select"
                      classNamePrefix="select"
                    /> */}

                    {users && users[0] && (
                      <MultiSelect
                        options={users[0]?.map((user) => ({
                          value: user.email,
                          label: user.email,
                        }))}
                        value={selectedUsers}
                        onChange={(selectedOptions) => {
                          setSelectedUsers(selectedOptions);
                          // Modified to ensure we're setting either new values or existing ones
                          const selectedValues = selectedOptions.map((option) => option.value);
                          setValue("assignedTo", selectedValues.length > 0 ? selectedValues : selectedUsers.map(user => user.value), {
                          shouldValidate: true,
                          });
                        }}
                        labelledBy="Select"
                        overrideStrings={{
                          selectSomeItems: "Select users...",
                          allItemsAreSelected: "All users are selected",
                        }}
                      />
                    )}

                    <input type="hidden" {...register("assignedTo", { required: "Assigned To is required" })} />

                    {errors.assignedTo && (
                      <span className="text-red-500">
                        {errors.assignedTo.message}
                      </span>
                    )}
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700">
                      Batch Status
                    </label>
                    <input
                      value={modalData?.status}
                      disabled
                      type="text"
                      className="bg-gray-200 border border-gray-300 text-gray-500 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 cursor-not-allowed"
                    />
                  </div>
                  <div className="text-left text-xs">
                    <label className="block text-sm font-medium text-gray-700">
                      Request Count
                    </label>
                    <div className="flex flex-col items-center">
                      <div className="flex ">
                        <div className="flex items-center justify-center">
                          {modalData?.total_requests}
                        </div>
                      </div>
                      <div className="flex mt-1">
                        <div className="flex items-center justify-center text-green-500">
                          {modalData?.is_done_count}
                        </div>
                        <div className="mx-1">|</div>
                        <div className="flex items-center justify-center text-red-500">
                          {modalData?.is_fail_count}
                        </div>
                        <div className="mx-1">|</div>
                        <div className="flex items-center justify-center text-yellow-500">
                          {modalData?.is_exhausted_count}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-span-full">
                    <label className="block text-sm font-medium text-gray-700">
                      Add Visuals
                    </label>
                    <input
                      {...register("file")}
                      type="file"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                    />
                  </div>

                  <div className="col-span-full">
                    <label
                      htmlFor="description"
                      className="block mb-2 text-sm font-medium text-gray-900"
                    >
                      Description<span className="text-red-500">*</span>
                    </label>
                    <textarea
                      {...register("description", {
                        required: "Description is required",
                        minLength: {
                          value: 2,
                          message:
                            "Description must be at least 2 characters long",
                        },
                      })}
                      // defaultValue={batchData[0]?.description || ""}
                      value={description}
                      onChange={(e) => {setDescription(e.target.value);setValue('description',e.target.value)}}
                      id="description"
                      rows="2"
                      className="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500"
                      placeholder="Write your thoughts here..."
                    ></textarea>
                    {errors.description && (
                      <span className="text-red-500">
                        {errors.description.message}
                      </span>
                    )}
                  </div>

                  <div className="col-span-full">
                    <div style={{ width: "100%" }}>
                      <h1 className="font-bold py-2">Comments</h1>
                      <div>
                        <DataTable
                          columns={batch_column}
                          data={notification[0]?.comment}
                          pagination
                          highlightOnHover
                          pointerOnHover
                          defaultSortFieldId={3}
                          defaultSortAsc={false}
                          customStyles={customStyles} // Apply custom styles here
                        />
                      </div>
                    </div>
                    <label
                      htmlFor="comment"
                      className="block mb-2 text-sm font-medium text-gray-900 pt-4"
                    >
                      Add Comment
                    </label>
                    <textarea
                      {...register("comment")}
                      id="comment"
                      rows="2"
                      className="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500"
                      placeholder="Add your Comment Here..."
                    ></textarea>
                  </div>

                  <div className="col-span-full text-center">
                    <button
                      type="submit"
                      className="bg-[#4880FF] px-4 py-2 rounded-md text-white hover:bg-blue-600"
                    >
                      Send Message
                    </button>
                  </div>
                </form>
              </div>
            </DialogContent>
          </ModalDialog>
        </Modal>
      )}

      {term === "image" && (
        <Modal open={!!layout} onClose={dataClear}>
          <ModalDialog
            layout={layout}
            sx={{
              margin: "auto",
              width: "95vw",
              height: "95vh", // Ensure it is responsive
            }}
          >
            <ModalClose />
            {/* <div className="text-lg w-full text-center border-b-2 py-2">
              {modalData?.client_id
                .replace(/([A-Z])/g, " $1")
                .trim()
                .split(" ")}
            </div> */}
            <div className="flex flex-row justify-between text-md p-8">
              <div className="text-md ">
                <span className="font-semibold">Batch Id: </span>{" "}
                {modalData?._id}
              </div>
              {/* <div className="flex flex-col gap-4 items-center">
                <div>Batch Creation Time: {modalData?.time_tag}</div>

                <div>Batch Last Updated Time:</div>
              </div> */}

              <div className="text-md">
                <div>
                  {" "}
                  <span className="font-semibold">
                    Batch Creation Time:{" "}
                  </span>{" "}
                  {modalData?.time_tag}
                </div>

                {/* <div>
                  {" "}
                  <span className="font-semibold">
                    {" "}
                    Batch Last Updated Time:
                  </span>
                  N/A
                </div> */}
              </div>
            </div>
            <DialogContent>
              <div className="w-full flex flex-row justify-between"></div>
              <div className="flex flex-row gap-10 justify-between h-[80vh]">
                <div className="w-[90%] h-full">
                  {console.log("heree")}
                  <Carousel
                    data={imageResponse}
                    selectedImageUrl={selectedImageUrl}
                    selectedImageData={selectedImageData}
                    onSlideChange={handleSlideChange}
                    currentSlideIndex={currentSlideIndex}
                  />
                </div>
                <div className="w-[10%] flex flex-col gap-5 h-full text-center text-[#4880FF] overflow-y-auto">
                  {imageResponse
                    ?.filter((item) => item.screenshot_url !== null) // Filter out items where screenshot_url is null
                    .map((item, index) => (
                      <div
                        key={index}
                        className="cursor-pointer flex flex-col items-center gap-2"
                        onClick={() =>
                          handleImageClick(item.screenshot_url, item)
                        }
                      >
                        {/* Display index number */}
                        <div className="text-xs text-gray-500">
                          #{index + 1}
                        </div>

                        <div className="hover:text-blue-600 border-2 rounded-full hover:border-blue-600">
                          <ImageIcon fontSize="large" />
                        </div>

                        <div className="text-xs text-black">
                          <p>
                            {new Date(
                              item.create_datetime || item.scrape_date
                            ).toLocaleDateString()}
                          </p>
                          <p>{item.time_tag || item.scrape_date}</p>
                        </div>
                      </div>
                    ))}
                </div>
              </div>

              {/* <div className="pt-[86px] pr-48">
                <div className="w-full text-center py-4 text-sm">
                  <span className="font-semibold">
                    Date and Time Generation
                  </span>
                  : {generationDateTime}
                </div>
              </div> */}
            </DialogContent>
          </ModalDialog>
        </Modal>
      )}

      {term === "bell-icon" && (
        <Modal
          open={!!layout}
          onClose={() => setLayout(undefined)}
          BackdropProps={{
            sx: {
              backdropFilter: "none", // Ensure no blur effect
              backgroundColor: "rgba(0, 0, 0, 0.5)", // Optional: darken background without blur
            },
          }}
        >
          <ModalDialog
            layout={layout}
            sx={{
              margin: "auto",
              width: "60vw",
              height: "60vh", // Ensure it is responsive
            }}
          >
            <ModalClose />
            <DialogTitle
              sx={{
                textAlign: "center",
                width: "full",
                display: "flex",
                justifyContent: "center",
                padding: "2%",
              }}
            >
              Notifications
            </DialogTitle>
            <DialogContent>
              {/* Toggle Button */}
              <div className="flex justify-center space-x-4 mb-4 w-full text-sm">
                <Button
                  variant={viewType === "sent" ? "contained" : "outlined"}
                  onClick={() => setViewType("sent")}
                  className="flex-grow"
                  sx={{
                    borderRadius: "9999px", // Fully rounded
                    textTransform: "none", // Prevent text from being capitalized
                  }}
                >
                  Sent
                </Button>
                <Button
                  variant={viewType === "received" ? "contained" : "outlined"}
                  onClick={() => setViewType("received")}
                  className="flex-grow"
                  sx={{
                    borderRadius: "9999px", // Fully rounded
                    textTransform: "none", // Prevent text from being capitalized
                  }}
                >
                  Received
                </Button>
              </div>

              <div className="flex justify-center">
                <div className="w-full">
                  <DataTable
                    columns={columns} // Use columns based on viewType
                    data={filteredData} // Replace with actual data
                    pagination
                    highlightOnHover
                    defaultSortFieldId={6}
                    defaultSortAsc={false}
                    pointerOnHover
                    customStyles={customStyles} // Apply custom styles here
                  />
                </div>
              </div>
            </DialogContent>
          </ModalDialog>
        </Modal>
      )}

      <Dialog
        open={open}
        onClose={() => handleClose(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="fixed inset-x-0 top-0 flex items-start justify-center"
      >
        <DialogTitle id="alert-dialog-title">Notify</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Confirm if you want to send message for Batch ID-
            {modalData?._id}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <button
            onClick={() => handleClose(true)}
            className="border border-blue-500  text-blue-500  hover:bg-blue-500 hover:text-white rounded-md px-3 py-2"
          >
            Confirm
          </button>
          <button
            onClick={() => handleClose(false)}
            className="border border-blue-500  text-blue-500 hover:bg-blue-500 hover:text-white rounded-md px-3 py-2 rounded-md"
          >
            Cancel
          </button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

export default LayoutModalDialog;
